<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <v-card-text>
        <v-form ref="form">
          <v-row class="pa-5" justify="space-around">
            <v-col cols="12" md="5">
              <h3 class="font-weight-bold">{{ $t("settings/profile:profile.docu-dialog-form-title") }}</h3>
            </v-col>
            <v-col class="d-none d-md-block" md="6"></v-col>

            <v-col cols="12" md="6">
              <DragAndDropFile ref="dragAndDrop" @fileChange="setFile($event)" custom-height="75vh"/>
            </v-col>

            <v-col cols="12" md="5">
              <v-text-field
                  v-model="documentation.name"
                  outlined
                  :label="$t('common:document-name')"
                  :rules="[ruleRequired($t('utils:rules.required'))]"
                  tabindex="1"
              />

              <DateField
                  ref="start"
                  @update="(v) => (documentation.start = v)"
                  :isClearable="true"
                  :label="$t('common:valid-from')"
                  tabindex="2"
              />

              <DateField
                  ref="end"
                  @update="(v) => (documentation.end = v)"
                  :isClearable="true"
                  :label="$t('common:valid-until')"
                  tabindex="3"
              />

              <v-select
                  outlined
                  ref="building.operator"
                  v-model="documentation.roleId"
                  :label="$t('common:role')"
                  :items="roleData"
                  item-value="id"
                  item-text="name"
                  :menu-props="{ bottom: true, offsetY: true}"
                  clearable
                  tabindex="4"
              />

              <BaseButton
                  color="primary"
                  :btn-text="$t('buttons:save')"
                  @clickedButton="uploadUserDocumentation()"
              />
              <DirtyConfirmButtonDialog
                  ref="dirtyDialog"
                  :btn-text="$t('buttons:back')"
                  color="grey"
                  :dialog-title="$t('dialog:dirty-save-btn-title')"
                  :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                  :button1-text="$t('dialog:dirty-save-btn-1-text')"
                  :button2-text="$t('dialog:dirty-save-btn-2-text')"
                  @clickedButton="closeDialog"
                  :dataToWatch="documentation"
                  hideOverlay
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DocumentationService from '@/modules/core/services/documentation-service';
import WorkerRoleService from '@/modules/core/services/worker-role-service';
import UserDocumentation from '@/modules/core/data/users-documentation';
import {ruleRequired, ruleMaxFileSize} from '@/modules/core/services/rules';
import Utils from '@/modules/core/services/utils';
import DateField from '@/modules/core/components/DateField';
import WorkerRole from "@/modules/core/data/worker-role";
import DataUtils from "@/modules/core/services/data-utils";
import DirtyConfirmButtonDialog from "@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog";
import BaseButton from "@/modules/core/components/Base/BaseButton";
import DragAndDropFile from "@/modules/core/components/DragAndDropFile"

export default {
  name: "UserDocumentationDialogForm",
  components: {
    DateField,
    DirtyConfirmButtonDialog,
    BaseButton,
    DragAndDropFile
  },
  data() {
    return {
      documentation: new UserDocumentation(),
      id: null,
      file: null,
      role: null,
      roleData: null,
      name: null,
      dialog: false,
      tableOptions: [],
      tableSearch: []
    }
  },
  methods: {
    setFile(item) {
      this.file = item;

      if (item) {
        let docuToParse = {
          fileType: item.type,
          src: URL.createObjectURL(item)
        }
        this.$refs.dragAndDrop.setPreviewSrc(docuToParse)
      } else {
        this.$refs.dragAndDrop.setPreviewSrc(null)
      }

      this.$refs.dragAndDrop.file = item;
      this.$refs.dragAndDrop.isUploading = false;
    },

    closeDialog() {
      this.dialog = false;
      this.file = null;
      this.$refs.dragAndDrop.clear();
      this.$refs.form.reset();
      this.$refs.start.localDate = ''
      this.$refs.end.localDate = ''
    },

    addDocu(options, search) {
      this.tableOptions = options;
      this.tableSearch = search;
      this.dialog = true;
    },

    uploadUserDocumentation() {

      if (!this.$refs.form.validate()) {
        return;
      }

      DocumentationService.postUserDocumentationToAPI(this.file, this.documentation,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:upload-success', {name: this.$t('common:document')}));
          this.$emit('updateDocus', this.tableOptions, this.tableSearch)
          this.closeDialog();
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:upload-failure', {name: this.$t('common:document')}))
        }
      )
    },
    ruleRequired,
    ruleMaxFileSize
  },
  computed: {
    currentLang() {
      return this.$store.state.translation.language;
    },
    fileSizeLimit() {
      return process.env.VUE_APP_UPLOAD_SIZE_DOCUMENT;
    }
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.$refs.form.resetValidation()
      });
    },
    dialog() {
      if(this.dialog) {
        WorkerRoleService.readAllFromAPI(
          (res) => {
            this.roleData = DataUtils.parseDataToObjectArray(res.data, WorkerRole);
            this.$refs.dirtyDialog.startWatch();
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:role_plural')}))
            this.$logger.error(error);
          }
        )
      }
    }
  }
}
</script>
